<template>
    <div class="layout">
        <navigation-component class="mb-5" />
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </div>
</template>

<script>


import NavigationComponent from "@/components/NavigationComponent";
export default {
    name: "PublicLayout", components: {
        NavigationComponent

    },
    mounted() {

    },
}
</script>

<style lang="scss" scoped>

</style>
